import { ActionsUnion, createAction } from "../definitions";
import {
    IMobilePageState,
    IGpsData,
    MobileActionTypes,
    IDriverActionNecessary,
    IGps,
    IBackground,
    IViewedLog,
    ILoginRequiredState,
    NetworkStates,
    ISyncInterval,
    ILastKnownSpeed,
    IIamUserRefreshPayload,
    IIamUserSessionInvalidatedPayload
} from "./types";
import * as logger from "../../utils/logger";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MobileActions = {
    setPageState: (payload: IMobilePageState) => createAction(MobileActionTypes.SET_PAGESTATE, payload),
    setCharging: (payload?: boolean) => createAction(MobileActionTypes.SET_CHARGING, payload),
    setBatteryLevel: (payload?: number) => createAction(MobileActionTypes.SET_BATTERYLEVEL, payload),
    setBackground: (payload?: IBackground) => {
        if (payload?.code) {
            logger.event(logger.Event.BACKGROUNDFAILURE, `Background state failure ${ payload?.code }`);
        }
        return createAction(MobileActionTypes.SET_BACKGROUND, payload);
    },
    setOnline: (payload?: NetworkStates) => createAction(MobileActionTypes.SET_ONLINE, payload),
    setDeviceCommunicating: (payload?: boolean) => createAction(MobileActionTypes.SET_DEVICE_COMMUNICATING, payload),
    setLastDeviceCommunicationDateTime: (payload?: string) => createAction(MobileActionTypes.SET_LAST_DEVICE_COMMUNICATION_DATETIME, payload),
    setGps: (payload: IGps) => createAction(MobileActionTypes.SET_GPS, payload),
    setEmbed: (payload?: boolean) => createAction(MobileActionTypes.SET_EMBED, payload),
    setEldMalfunction: (payload?: boolean) => createAction(MobileActionTypes.SET_ELDMALFUNCTION, payload),
    setNewUpcomingViolation: (payload?: boolean) => createAction(MobileActionTypes.SET_NEWUPCOMINGVIOLATION, payload),
    setEldDiagnostic: (payload?: boolean) => createAction(MobileActionTypes.SET_ELDDIAGNOSTIC, payload),
    setDiagnosticViewed: (payload?: boolean) => createAction(MobileActionTypes.SET_DIAGNOSTICVIEWED, payload),
    setLanguage: (payload?: string) => createAction(MobileActionTypes.SET_LANGUAGE, payload),
    setDriverActionNecessary: (payload: IDriverActionNecessary) => createAction(MobileActionTypes.SET_DRIVERACTIONNECESSARY, payload),
    setIoxAttached: (payload?: boolean) => createAction(MobileActionTypes.SET_IOX_ATTACHED, payload),
    setGpsData: (payload?: IGpsData) => createAction(MobileActionTypes.SET_GPS_DATA, payload),
    setLastViewedLog: (payload?: IViewedLog) => createAction(MobileActionTypes.SET_LAST_VIEWED_LOG, payload),
    setNewMessage: (payload?: boolean) => createAction(MobileActionTypes.SET_NEW_MESSAGE, payload),
    setPreviousPage: (payload?: string) => createAction(MobileActionTypes.SET_PREVIOUS_PAGE, payload),
    setLoginRequired: (payload: ILoginRequiredState) => createAction(MobileActionTypes.SET_LOGIN_REQUIRED, payload),
    setPcLimitWarningMessage: (payload?: string) => createAction(MobileActionTypes.SET_PCLIMIT_WARNING, payload),
    setPageLoaded: (payload: string) => createAction(MobileActionTypes.SET_PAGE_LOADED, payload),
    setPendoResourceCenterAvailable: (payload: boolean) => createAction(MobileActionTypes.SET_PENDO_RESOURCE_CENTER_AVAILABLE, payload),
    setTripCategorizationSyncInterval: (payload: ISyncInterval) => createAction(MobileActionTypes.SET_TRIP_CATEGORIZATION_SYNC_INTERVAL, payload),
    setLastKnownSpeed: (payload: ILastKnownSpeed) => createAction(MobileActionTypes.SET_LAST_KNOWN_SPEED, payload),
    setIamRefreshState: (payload: IIamUserRefreshPayload) => createAction(MobileActionTypes.SET_IAM_USER_REFRESH_STATE, payload),
    setIamSessionInvalidatedState: (payload: IIamUserSessionInvalidatedPayload) => createAction(MobileActionTypes.SET_IAM_SESSION_INVALIDATED_STATE, payload),
    setDvirDurationStartTime: (payload: Date | undefined) => createAction(MobileActionTypes.SET_DVIR_DURATION_START_TIME, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MobileActions = ActionsUnion<typeof MobileActions>;
